module.exports = __webpack_public_path__ + "67fdd4dcef682f280efeb7ccf4907d31.MP3";